import React from 'react';
import PropTypes from 'prop-types';
import GameEventProp from '../../propTypes/gameEventProp';
import translate from '../../../../commonComponents/translate';

function TimelineItemFooter({ t, event, onLikeClick, onCommentClick }) {
  return (
    <div className="timeline-footer">
      <a
        className={`timeline-footer-action ${
          event.isLiked ? 'timeline-footer-action__active' : ''
        }`}
        onClick={() => onLikeClick(event)}
      >
        <i className="flaticon-like" />
        {t('challengeDetails_likes')}
        {` (${event.likes})`}
      </a>
      <a
        className="timeline-footer-action"
        onClick={() => onCommentClick(event)}
      >
        <i className="flaticon-comment" />
        {t('challengeDetails_comments')}
        {` (${event.comments})`}
      </a>
    </div>
  );
}

TimelineItemFooter.propTypes = {
  t: PropTypes.func.isRequired,
  event: PropTypes.shape(GameEventProp.propType).isRequired,
  onLikeClick: PropTypes.func.isRequired,
  onCommentClick: PropTypes.func.isRequired,
};

export default translate(TimelineItemFooter);
